/**
 * Handles core Header interactions (Sticky Header).
 */
export const initHeader = (): void => {
  initStickyHeader();
};

const initStickyHeader = () => {
  const header = document.querySelector<HTMLElement>(".site-header");
  if (!header) return;

  // Reduced threshold from 100 to 10 so it turns white almost immediately on scroll
  const threshold = 10;
  let isSticky = false;

  window.addEventListener(
    "scroll",
    () => {
      const shouldBeSticky = window.scrollY > threshold;
      if (shouldBeSticky !== isSticky) {
        isSticky = shouldBeSticky;
        header.classList.toggle("is-sticky", isSticky);
      }
    },
    { passive: true },
  );
};
